import { Breadcrumb, Button, Card, Icon, message, Modal, Table, Upload } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import { gql } from 'apollo-boost';
import React, { FC, useState } from 'react';
import { Mutation } from 'react-apollo';
import { Link } from 'react-router-dom';
import { notEmpty } from 'src/utils/collections';
import * as xlsx from 'xlsx';

export const UpgradeEnrollment: FC = () => {
  const [visible, setVisible] = useState(false);

  const [upgradeList, setUpgradeList] = useState<
    { upgradeSkuId: number; enrollmentId: string; userId: string; sameTeacher: boolean }[]
  >([]);

  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const BATCH_UPGRADLE_ENROLLMET = gql`
    mutation batchUpgradeEnrollment($args: BatchUpgradeEnrollmentArgs) {
      batchUpgradeEnrollment(args: $args)
    }
  `;

  const MainBreadcrumb = () => {
    return (
      <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
        <Breadcrumb.Item>
          <Link to={`/Home`}>首页</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>用户升级</Breadcrumb.Item>
      </Breadcrumb>
    );
  };

  const showImportModal = () => {
    setVisible(true);
  };
  const handleImportCancel = () => {
    setVisible(false);
  };

  const handleImportOk = () => {
    message.success('导入成功');
    setFileList([]);
    setUpgradeList([]);
    setVisible(false);
  };

  const uploadProps = () => {
    const uploadProps = {
      beforeUpload: (file: UploadFile | Blob) => {
        const oneFile = file as UploadFile;
        if (oneFile.status !== 'removed') {
          const fileList = [oneFile];
          setFileList(fileList);

          const reader = new FileReader();
          const blob = file as Blob;
          reader.readAsBinaryString(blob);
          reader.onload = (event: any) => {
            const data = event.target.result;
            const workbook = xlsx.read(data, {
              type: 'binary',
            });
            const sheetName = workbook.SheetNames[workbook.SheetNames.length - 1];
            if (!sheetName) {
              return;
            }
            const upgradeObjList: {
              upgradeSkuId: number;
              enrollmentId: string;
              userId: string;
              sameTeacher?: boolean;
            }[] = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName]) || [];
            setUpgradeList(
              upgradeObjList.map(item => {
                const sameTeacher = item.sameTeacher;
                return {
                  upgradeSkuId: item.upgradeSkuId,
                  enrollmentId: item.enrollmentId,
                  userId: item.userId,
                  sameTeacher: notEmpty(sameTeacher) ? sameTeacher : true,
                };
              }),
            );
          };
        }
        return false;
      },
      onRemove: () => {
        setFileList([]);
        setUpgradeList([]);
      },
    };

    return uploadProps;
  };

  return (
    <>
      {MainBreadcrumb()}
      <Card>
        <Mutation mutation={BATCH_UPGRADLE_ENROLLMET} variables={{ args: { list: upgradeList } }}>
          {(batchUpgradeEnrollment, { loading, error }) => {
            if (error) {
              message.error('导入失败');
            }
            return (
              <>
                <Button style={{ marginRight: 8 }} onClick={() => showImportModal()}>
                  升级
                </Button>
                <Modal
                  title="用户升级信息"
                  visible={visible}
                  onOk={async () => {
                    if (!upgradeList.length) {
                      return;
                    }
                    await batchUpgradeEnrollment();
                    handleImportOk();
                    return;
                  }}
                  onCancel={handleImportCancel}
                >
                  <Upload {...uploadProps()} accept=".xls, .xlsx, .csv" fileList={fileList} multiple={false}>
                    <Button>
                      <Icon type="upload" /> 选择文件
                    </Button>
                  </Upload>
                  <Table
                    pagination={false}
                    scroll={{ y: 200 }}
                    dataSource={upgradeList}
                    rowKey={row => `${row.enrollmentId}`}
                  >
                    <Table.Column key="enrollmentId" dataIndex="enrollmentId" title="enrollmentId" />
                    <Table.Column key="upgradeSkuId" dataIndex="upgradeSkuId" title="升级skuId" />
                    <Table.Column key="userId" dataIndex="userId" title="用户Id" />
                    <Table.Column
                      key="sameTeacher"
                      dataIndex="sameTeacher"
                      title="是否相同老师"
                      render={sameTeacher => (sameTeacher ? '是' : '否')}
                    />
                  </Table>
                </Modal>
              </>
            );
          }}
        </Mutation>
      </Card>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/screens/enrollment/UpgradeEenrollment.tsx